import { CountryCodes } from '@/enums/general'

// Orientations / Slugs
export const Orientations = Object.freeze({
  menoriginals: 'men-originals',
  menone: 'men-one',
  boysoriginals: 'boys-originals',
  socksoriginals: 'originals-socks-regular',
  sneakersocksoriginals: 'originals-socks-sneaker',
  womenbralette: 'women-bralette',
  womenhipster: 'women-hipster',
  undershirts: 'men-undershirt'
})

// Orientations / Slugs
export const NewOrientations = Object.freeze({
  men: 'men',
  boys: 'boys',
  women: 'women',
  addon: 'addon'
})

// Orientations by Group Id's
export const OrientationsByGroupIds = Object.freeze({
  1: Orientations.menoriginals,
  2: Orientations.menone,
  3: Orientations.boysoriginals,
  21: Orientations.socksoriginals
})

// Orientations by Group Id's
export const OrientationSlugsByGroupIds = Object.freeze({
  1: Orientations.menoriginals,
  2: Orientations.menone,
  3: Orientations.boysoriginals,
  21: Orientations.socksoriginals
})

// Orientations first release dates
export const OrientationsStartDates = Object.freeze({
  1: '15-04-2015',
  2: '01-01-2019',
  3: '15-4-2018',
  21: '1-9-2021'
})

// Orientation names by Group Id's
export const OrientationsNamesByGroupIds = Object.freeze({
  1: 'Men Originals',
  2: 'Men One',
  3: 'Boys Originals',
  21: 'Socks'
})

// Group Id's by orientation names
export const GroupIdsByName = Object.freeze({
  [Orientations.menoriginals]: Object.keys(OrientationsByGroupIds)[0],
  [Orientations.menone]: Object.keys(OrientationsByGroupIds)[1],
  [Orientations.boysoriginals]: Object.keys(OrientationsByGroupIds)[2],
  [Orientations.socksoriginals]: Object.keys(OrientationsByGroupIds)[3],
  socks: Object.keys(OrientationsByGroupIds)[3]
})

// TODO: move to backend
// Men Originals and Men One Subscription Prices
export const MenPrices = Object.freeze({
  [CountryCodes.austria]: 11.99,
  [CountryCodes.belgium]: 11.99,
  [CountryCodes.denmark]: 99,
  [CountryCodes.germany]: 11.99,
  [CountryCodes.spain]: 11.99,
  [CountryCodes.france]: 11.99,
  [CountryCodes.netherlands]: 11.99,
  [CountryCodes.unitedKingdom]: 11.99,
  [CountryCodes.sweden]: 124,
  [CountryCodes.italy]: 11.99,
  [CountryCodes.poland]: 49,
  [CountryCodes.switzerland]: 11.99,
  [CountryCodes.ireland]: 11.99,
  [CountryCodes.luxembourg]: 11.99,
  [CountryCodes.portugal]: 11.99,
  [CountryCodes.finland]: 11.99,
  [CountryCodes.norway]: 130,
  [CountryCodes.czechRepublic]: 235
})

export const WomenPrices = Object.freeze({
  [CountryCodes.austria]: 12.99,
  [CountryCodes.belgium]: 12.99,
  [CountryCodes.denmark]: 110,
  [CountryCodes.germany]: 12.99,
  [CountryCodes.spain]: 12.99,
  [CountryCodes.france]: 12.99,
  [CountryCodes.netherlands]: 12.99,
  [CountryCodes.unitedKingdom]: 12.99,
  [CountryCodes.sweden]: 151,
  [CountryCodes.italy]: 12.99,
  [CountryCodes.poland]: 57,
  [CountryCodes.switzerland]: 12.99,
  [CountryCodes.ireland]: 12.99,
  [CountryCodes.luxembourg]: 12.99,
  [CountryCodes.portugal]: 12.99,
  [CountryCodes.finland]: 12.99,
  [CountryCodes.norway]: 153,
  [CountryCodes.czechRepublic]: 329
})

// Boys Originals Subscription Prices
export const BoysPrices = Object.freeze({
  [CountryCodes.austria]: 9.99,
  [CountryCodes.belgium]: 9.99,
  [CountryCodes.denmark]: 89,
  [CountryCodes.germany]: 9.99,
  [CountryCodes.spain]: 9.99,
  [CountryCodes.france]: 9.99,
  [CountryCodes.netherlands]: 9.99,
  [CountryCodes.unitedKingdom]: 9.99,
  [CountryCodes.sweden]: 114,
  [CountryCodes.italy]: 9.99,
  [CountryCodes.poland]: 44,
  [CountryCodes.switzerland]: 9.99,
  [CountryCodes.ireland]: 9.99,
  [CountryCodes.luxembourg]: 9.99,
  [CountryCodes.portugal]: 9.99,
  [CountryCodes.finland]: 9.99,
  [CountryCodes.norway]: 119,
  [CountryCodes.czechRepublic]: 212
})

// Socks Originals Subscription Prices
export const SocksPrices = Object.freeze({
  [CountryCodes.austria]: 8.99,
  [CountryCodes.belgium]: 8.99,
  [CountryCodes.denmark]: 67,
  [CountryCodes.germany]: 8.99,
  [CountryCodes.spain]: 8.99,
  [CountryCodes.france]: 8.99,
  [CountryCodes.netherlands]: 8.99,
  [CountryCodes.unitedKingdom]: 8.99,
  [CountryCodes.sweden]: 93,
  [CountryCodes.italy]: 8.99,
  [CountryCodes.poland]: 44,
  [CountryCodes.switzerland]: 9.95,
  [CountryCodes.ireland]: 9.99,
  [CountryCodes.luxembourg]: 9.99,
  [CountryCodes.portugal]: 8.99,
  [CountryCodes.finland]: 9.99,
  [CountryCodes.norway]: 103,
  [CountryCodes.czechRepublic]: 212
})

// Socks Originals Subscription Prices With Active Boxers Membership
export const SocksDiscountPrices = Object.freeze({
  [CountryCodes.austria]: 4.99,
  [CountryCodes.belgium]: 4.99,
  [CountryCodes.denmark]: 37,
  [CountryCodes.germany]: 4.99,
  [CountryCodes.spain]: 4.99,
  [CountryCodes.france]: 4.99,
  [CountryCodes.netherlands]: 4.99,
  [CountryCodes.unitedKingdom]: 4.99,
  [CountryCodes.sweden]: 52,
  [CountryCodes.italy]: 4.99,
  [CountryCodes.poland]: 28,
  [CountryCodes.switzerland]: 5.95,
  [CountryCodes.ireland]: 5.99,
  [CountryCodes.luxembourg]: 5.99,
  [CountryCodes.portugal]: 4.99,
  [CountryCodes.finland]: 5.99,
  [CountryCodes.norway]: 57,
  [CountryCodes.czechRepublic]: 118
})

export const UndershirtsPrices = Object.freeze({
  [CountryCodes.austria]: 12.99,
  [CountryCodes.belgium]: 12.99,
  [CountryCodes.denmark]: 97,
  [CountryCodes.germany]: 12.99,
  [CountryCodes.spain]: 12.99,
  [CountryCodes.france]: 12.99,
  [CountryCodes.netherlands]: 12.99,
  [CountryCodes.unitedKingdom]: 12.99,
  [CountryCodes.sweden]: 149,
  [CountryCodes.italy]: 12.99,
  [CountryCodes.poland]: 55,
  [CountryCodes.switzerland]: 12.99,
  [CountryCodes.ireland]: 12.99,
  [CountryCodes.luxembourg]: 12.99,
  [CountryCodes.portugal]: 12.99,
  [CountryCodes.finland]: 12.99,
  [CountryCodes.norway]: 155,
  [CountryCodes.czechRepublic]: 325
})

export const UndershirtsDiscountPrices = Object.freeze({
  [CountryCodes.austria]: 6.99,
  [CountryCodes.belgium]: 6.99,
  [CountryCodes.denmark]: 56,
  [CountryCodes.germany]: 6.99,
  [CountryCodes.spain]: 6.99,
  [CountryCodes.france]: 6.99,
  [CountryCodes.netherlands]: 6.99,
  [CountryCodes.unitedKingdom]: 6.99,
  [CountryCodes.sweden]: 80,
  [CountryCodes.italy]: 6.99,
  [CountryCodes.poland]: 30,
  [CountryCodes.switzerland]: 6.99,
  [CountryCodes.ireland]: 6.99,
  [CountryCodes.luxembourg]: 6.99,
  [CountryCodes.portugal]: 6.99,
  [CountryCodes.finland]: 6.99,
  [CountryCodes.norway]: 95,
  [CountryCodes.czechRepublic]: 177
})

// Product Types
export const ProductTypes = Object.freeze({
  boxers: 'boxers',
  socks: 'socks'
})

// Product category Ids
export const ProductCategoryIds = Object.freeze({ // todo:: remove
  [ProductTypes.boxers]: 1,
  [ProductTypes.socks]: 2
})

// Product Types by Id's
export const ProductTypesByIds = Object.freeze({
  [ProductCategoryIds[ProductTypes.boxers]]: ProductTypes.boxers,
  [ProductCategoryIds[ProductTypes.socks]]: ProductTypes.socks
})

export const mensSizes = [
  { value: 1, label: 'XS' },
  { value: 2, label: 'S' },
  { value: 3, label: 'M' },
  { value: 4, label: 'L' },
  { value: 5, label: 'XL' },
  { value: 6, label: 'XXL' },
  { value: 12, label: '3XL' }
]

export const boysSizes = [
  { value: 7, label: '104' },
  { value: 8, label: '110-116' },
  { value: 9, label: '122-128' },
  { value: 10, label: '134-140' },
  { value: 11, label: '146-152' }
]

// Sizes
export const Sizes = Object.freeze({
  mens: mensSizes,
  boys: boysSizes,
  all: [...mensSizes, ...boysSizes]
})

export const ProductGroupSizeIds = Object.freeze({
  [Orientations.womenbralette]: 152,
  [Orientations.womenhipster]: 156
})
